import gql from 'graphql-tag';

export const UPDATE_ADDON_STATUS = gql`
  mutation updateAddOnStatus($input: UpdateAddOnStatusInput) {
    updateAddOnStatus(input: $input)
  }
`;
